import { FormDataTypes } from "@/src/types/FormDataTypes";
import { apiPost } from "@/src/services/apiClient";

export const validateLvmAccount = async (values: FormDataTypes["values"]): Promise<string | null> => {
  const lvmErrorMessage =
    "Leider konnten wir unter den angegebenen Daten für den angefragten Bereich keinen aktiven Versicherungsschutz ermitteln. Bitte wenden Sie sich direkt an die LVM.";

  try {
    const apiResult = await apiPost(`/lvm/validate_account`, {
      productClassName: values.product,
      insurancePolicyNumber: values.insurancePolicyNumber,
    });

    if (!apiResult.covered) {
      return lvmErrorMessage;
    }
  } catch (error) {
    return lvmErrorMessage;
  }

  return null;
};
